import { ref, computed, onMounted } from 'vue'
import { checkMobile } from '../../utils/utils'
import { format } from 'date-fns'
import { Milestone } from '../../../api/v2/models/user_goal'

interface UseGoalMilestoneProps {
  milestone: Milestone
  isFirst?: boolean
  isLast?: boolean
}

export function useGoalMilestone(props: UseGoalMilestoneProps) {
  const mobile = ref(checkMobile())

  const progressPercent = computed(() => {
    const length = props.milestone.enrollments.length

    if (length === 0) {
      return 100
    }

    let total = 0
    props.milestone.enrollments.forEach((item) => (total += item.progressPercent))

    return Math.round(total / length)
  })

  function dateFormat(date: string, formatDate: string = 'MM/DD'): string {
    return format(date, formatDate)
  }

  return {
    mobile,
    progressPercent,
    dateFormat
  }
}
